import { Grid } from '@mui/material';
import AlarmWidget from '../alarmWidget/AlarmWidget';
import AnalyzerStatusWidget from '../analyzerStatusWidget/AnalyzerStatusWidget';

import RecordingStatusWidget from '../recordingStatusWidget/RecordingStatusWidget';
import WeatherWidget from '../weather/WeatherWidget';
import { useIsOperator } from '../auth/hooks/useIsOperator';
import WeatherAlertsWidget from 'features/weatherAlertsWidget/WeatherAlertsWidget';
import { useSystemModules } from 'features/systemModules/api/getSystemModules';
import MetricTrackerWidget from 'features/metricTracker/MetricTrackerWidget';
import NotePadWidget from 'features/notepad/NotepadWidget';
import ConnectionStatusWidget from '../systemInfo/ConnectionStatusWidget';

const DashBoard = () => {
  const isOperator = useIsOperator();
  const { data: modules } = useSystemModules({});

  return (
    <Grid container spacing={3}>
      <Grid
        container
        direction='column'
        item
        xs={6}
        md={5}
        lg={5}
        xl={3}
        style={{ minWidth: '30rem' }}
      >
        <Grid item sx={{ pb: '1.8rem' }}>
          <AlarmWidget />
        </Grid>
        {isOperator && (
          <Grid item sx={{ pb: '1.8rem' }}>
            <RecordingStatusWidget />
          </Grid>
        )}
        {modules?.WEATHER && (
          <Grid item>
            <WeatherAlertsWidget />
          </Grid>
        )}
      </Grid>
      <Grid
        item
        container
        xs={6}
        md={6}
        lg={5}
        xl={4}
        direction='column'
        style={{ minWidth: '35rem' }}
      >
        <Grid item style={{ maxWidth: '100%', paddingBottom: '1.8rem' }}>
          <AnalyzerStatusWidget />
        </Grid>
        {modules?.WEATHER && (
          <Grid item style={{ maxWidth: '100%', paddingBottom: '1.8rem' }}>
            <WeatherWidget />
          </Grid>
        )}
        <Grid item style={{ maxWidth: '100%', paddingBottom: '1.8rem' }}>
          <ConnectionStatusWidget isNav={false} />
        </Grid>
      </Grid>

      <Grid
        item
        container
        xs={6}
        md={6}
        lg={5}
        xl={4}
        direction='column'
        style={{ minWidth: '35rem' }}
      >
        <Grid item style={{ paddingBottom: '1.8rem' }}>
          <MetricTrackerWidget />
        </Grid>
        <Grid item>
          <NotePadWidget />
        </Grid>
      </Grid>
    </Grid>
  );
};

export default DashBoard;
